import { useNavigationState } from '../../context';

import { ScreensType } from '.';

export default function StaticStackRenderer({ screens }: { screens: ScreensType }) {
    const { currentScreen, params } = useNavigationState();

    if (!currentScreen) {
        return null;
    }

    const { component: CurrentScreenComp, params: screenParams } = screens[currentScreen];

    // Merge default screen params with navigation params
    const mergedParams = { ...screenParams, ...params };

    return <CurrentScreenComp {...mergedParams} />;
}
